import React from "react";
import ComponentBloco from "../blocos/Component";

class BlocosBox extends React.Component{
  constructor(props){
    super(props);
  }

  render (){
    const bloco = this.props.bloco;
    let _id = bloco.id;
    let _ativo = this.props.ativo ? " ativo " : " hide ";
    let _className = "bloco-planilha-wrapper "+_ativo;
    const data = bloco;
    const sexo = this.props.sexo;
    
    return(
      <div className={_className} data-bloco={_id} data-key={this.props.position}>
        <ComponentBloco
          sexo={sexo}
          detalhe={data}
          onRemoveHandler={this.props.onRemoveHandler}
          position={this.props.position}
        />
      </div>
    )
  }
}

export default BlocosBox;



// WEBPACK FOOTER //
// ./src/classes/blocos-planilha/BlocosBox.js